import React, { useEffect, useState } from 'react'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'
import Select from 'react-select'
import { CButton, CFormLabel } from '@coreui/react'
import SaveExtra from '../../services/general/saveExtraData.api'
import toast from 'react-hot-toast'
import { toastConfig } from '../../constants/other.config'
import CheckOptionSelections from '../../components/shared/CheckOptionSelections'
import SaveQuestionProvider from '../../services/general/saveQuestionsProvider.api'
const MediaCopy = ({ setActiveTab, setParentAccordions, parentId = null, setSuggestionModalVisible, type = 'assessment', ApiCallingType = 'AssesmentSuggestions', differentModuleCopyFunctionality = false, attachedType = 'title', setShowMediaModel, fileStatmentData }) => {
  const [suggestionData, setSuggestionData] = useState([])
  const [isPageLoading, setIsPageLoading] = useState(false)
  const [selectedDiagnosis, setSelectedDiagnosis] = useState(null)
  const [diagnosisOptions, setDiagnosisOptions] = useState([])
  const [selectedTitles, setSelectedTitles] = useState([])
  const [titleOptions, setTitleOptions] = useState([])
  const [statementOption, setStatementOption] = useState([])
  const [selectedStatement, setSelectedStatement] = useState([])
  const [planOptions, setPlanOptions] = useState([])
  const [selectedPlan, setSelectedPlan] = useState(null)
  const [questionData, setQuestionData] = useState(null)
  const [selectedModuleType, setSelectedModuleType] = useState({ value: 'AssesmentSuggestions', label: 'Assessment' })
  const [selectedFile, setSelectedFile] = useState([])
  const [moduleType, setModuleType] = useState([
    { value: 'HPI', label: 'HPI' },
    { value: 'followup', label: 'Follow Up' },
    { value: 'Incident', label: 'Incident' },
    { value: 'AssesmentSuggestions', label: 'Assessment' },
    { value: 'differentialDiagnosis', label: 'Differential Diagnosis' },
    { value: 'generalPlanStatements', label: 'Template' },
  ])
  const mediaType = [
    { value: 'image', label: 'Image' },
    { value: 'document', label: 'Document' },
    { value: 'video', label: 'Video' },
  ]
  const [selectedMediaType, setSelectedMediaType] = useState([])

  const extractLinkedAssessments = (data) => {
    const processOptions = (options) =>
      options?.reduce((acc, option) => {
        if (option.linkedAssessment) {
          acc.push(...option.linkedAssessment)
        }
        if (option.linkedQuestion) {
          if (Array.isArray(option.linkedQuestion)) {
            option.linkedQuestion.forEach((nestedQuestion) => {
              acc.push(...processOptions(nestedQuestion.options))
            })
          } else if (typeof option.linkedQuestion === 'object') {
            acc.push(...processOptions(option.linkedQuestion.options))
          }
        }

        return acc
      }, []) || []

    return (
      data?.questionData?.reduce((acc, question) => {
        acc.push(...processOptions(question.options))
        return acc
      }, []) || []
    )
  }

  const getData = async (type = 'AssesmentSuggestions') => {
    setIsPageLoading(true)
    try {
      if (type === 'AssesmentSuggestions' || type === 'differentialDiagnosis' || type === 'generalPlanStatements') {
        let data = await SaveExtra('Get_By_Type', type, '', '')
        data = JSON.parse(data.d)?.Data || []
        if (data) {
          data = data?.map((item) => {
            return {
              Id: item.Id,
              Data: JSON.parse(item?.JsonData),
            }
          })
        }
        let result = data.filter((item) => item?.Data.diagnosis.value === selectedDiagnosis?.value)

        if (result.length > 0) {
          handleAllTitles(result[0].Data.accordions)
        } else {
          setTitleOptions([])
          setStatementOption([])
        }
        setSuggestionData(data)
      } else if (type === 'HPI' || type === 'Incident' || type === 'followup') {
        let formattedData
        if (selectedDiagnosis) {
          formattedData = await SaveQuestionProvider('GET', '', type, selectedDiagnosis?.value?.toString(), '')
          if (formattedData) {
            formattedData = JSON.parse(formattedData.d)?.Data || []
            formattedData = formattedData[0] || []
            if (formattedData.questionData) {
              formattedData = {
                ...formattedData,
                questionData: JSON.parse(formattedData.questionData).filter((item) => item !== null),
              }
            }
            if (formattedData) {
              const linkedAssessments = extractLinkedAssessments(formattedData)
              if (linkedAssessments.length > 0) {
                handleAllTitles(linkedAssessments)
              } else {
                setTitleOptions([])
                setStatementOption([])
              }
              setQuestionData(linkedAssessments)
            }
          }
        } else {
          // window.alert("Please Select Diagnosis  ")
        }
      }
      // setSelectedDiagnosis(parentDiagnosis)
    } catch (error) {
      console.log(error)
    } finally {
      setIsPageLoading(false)
    }
  }

  const updateDiagnosisOptions = async () => {
    try {
      let response = await GetDiagnosisData('')
      let diagnosis = JSON.parse(response.d)?.Data
      const options = diagnosis.map((item) => ({
        value: item.id,
        label: item.Name,
      }))
      setDiagnosisOptions(options)
    } catch (error) {
      console.error('Error updating diagnosis options:', error)
    }
  }

  const handlePlanStatement = (planStatement) => {
    const extractSuggestions = (accordions) => {
      return accordions.flatMap((accordion) => {
        const currentSuggestions = accordion.suggestions.suggestionName || []
        const childSuggestions = accordion.children?.length > 0 ? extractSuggestions(accordion.children) : []
        return [...currentSuggestions, ...childSuggestions]
      })
    }
    const planSuggestions = planStatement.flatMap((plan) => {
      return statementOption.flatMap((option) => {
        const matchingPlan = option.orders.planSuggestions?.find((planSuggestion) => planSuggestion.name === plan.label)

        if (matchingPlan && matchingPlan.accordions?.length > 0) {
          return extractSuggestions(matchingPlan.accordions)
        }

        return []
      })
    })

    if (planSuggestions.length > 0) {
      setPlanOptions(() => {
        let options = planSuggestions.map((plan, i) => {
          return {
            value: i,
            label: plan,
          }
        })
        return options
      })
    }
  }

  const handleAllDescriptionOptions = (filterSuggestion) => {}

  const handleAllStatement = (statements) => {
    try {
      const extractStatements = (item) => {
        const currentSuggestions = item?.suggestions || []
        const childSuggestions = item?.children && item.children.length > 0 ? item.children.flatMap((child) => extractStatements(child)) : []

        return [currentSuggestions, ...childSuggestions]
      }

      const allStatements = statements.flatMap((item) => extractStatements(item.data))

      if (allStatements.length > 0) {
        const filterSuggestion = allStatements.map((item, i) => {
          const suggestions = item?.suggestionName?.map((statement, index) => {
            const uniqueValue = `${i}${index}${statement.name || statement.id || 'statement'}`

            return {
              value: uniqueValue,
              label: statement.name,
              description: statement.description,
              attached: statement.attached || null,
            }
          })

          // if (item?.description && item.description !== "") {
          //     suggestions.unshift({
          //         value: `${i}parent-description`,
          //         label: item.title,
          //         description: item.description,
          //     });
          // }

          return {
            data: suggestions,
            orders: item,
          }
        })
        setStatementOption(filterSuggestion)
      }
    } catch (error) {
      console.error('Error handling all statements:', error)
    }
  }

  const handleAllTitles = (allSuggestionsFromAccordions) => {
    try {
      const extractOptions = (items, parentPath = '') => {
        return items.flatMap((item, index) => {
          const uniqueValue = `${parentPath}${index}`
          const option = {
            value: uniqueValue,
            label: item.title,
            description: item.description,
            attached: item?.attached || null,
            data: item,
          }

          const childOptions = item.children ? extractOptions(item.children, `${uniqueValue}`) : []
          return [option, ...childOptions]
        })
      }

      // const title = extractOptions(allSuggestionsFromAccordions);
      const statement = extractOptions(allSuggestionsFromAccordions)
      const title = statement.filter((option) => option.label)
      setTitleOptions(title)
      handleAllStatement(statement)
      // const title = extractOptions(allSuggestionsFromAccordions).filter((option) => option.label);

      // setTitleOptions(title)
      // handleAllStatement(title)
    } catch (error) {
      console.error('Error handling all titles:', error)
    }
  }

  const handleChangeDiagnosis = (type) => {
    getData(type)
  }

  useEffect(() => {
    handleChangeDiagnosis(selectedModuleType.value)
  }, [selectedModuleType])

  useEffect(() => {
    if (selectedDiagnosis) {
      try {
        handleChangeDiagnosis(selectedModuleType.value)
      } catch (error) {
        console.error('Error updating diagnosis data:', error)
      }
    }
  }, [selectedDiagnosis])

  useEffect(() => {
    try {
      if (selectedTitles.length > 0) {
        handleAllStatement(selectedTitles)
      } else if (selectedTitles?.length === 0) {
        handleChangeDiagnosis(selectedModuleType.label)
      }
    } catch (error) {
      console.error(error)
    }
  }, [selectedTitles])

  useEffect(() => {
    if (selectedStatement) {
      handleAllDescriptionOptions(selectedStatement)
    }
  }, [selectedStatement])

  useEffect(() => {
    updateDiagnosisOptions()
    getData()
  }, [])

  const handleStatementSubmit = () => {
    try {
      const selectedFiles =
        selectedFile?.map((file) => ({
          type: selectedMediaType?.find((type) => file.value.includes(type.value))?.value || 'document',
          url: file.value,
          fileName: file?.label || '',
        })) ?? []

      const updateSuggestionsRecursively = (accordions) =>
        accordions.map((accordion) =>
          accordion.id === fileStatmentData.parentId
            ? {
                ...accordion,
                suggestions: {
                  ...accordion.suggestions,
                  suggestionName: accordion.suggestions.suggestionName.map((suggestion) =>
                    suggestion.name === fileStatmentData.name
                      ? {
                          ...suggestion,

                          attached: {
                            image: [
                              ...(suggestion.attached?.image ?? []),
                              ...selectedFiles
                                .filter((f) => f.type === 'image')
                                .map((f) => ({
                                  url: f.url,
                                  fileName: f.fileName,
                                })),
                            ].flat(),
                            video: [
                              ...(suggestion.attached?.video ?? []),
                              ...selectedFiles
                                .filter((f) => f.type === 'video')
                                .map((f) => ({
                                  url: f.url,
                                  fileName: f.fileName,
                                })),
                            ].flat(),
                            document: [
                              ...(suggestion.attached?.document ?? []),
                              ...selectedFiles
                                .filter((f) => f.type === 'document')
                                .map((f) => ({
                                  url: f.url,
                                  fileName: f.fileName,
                                })),
                            ].flat(),
                          },
                        }
                      : suggestion,
                  ),
                },
                children: accordion.children ? updateSuggestionsRecursively(accordion.children) : [],
              }
            : {
                ...accordion,
                children: accordion.children ? updateSuggestionsRecursively(accordion.children) : [],
              },
        )

      setParentAccordions((prev) => {
        if (!prev || !prev.accordions?.length) {
          toast.error('No accordions to update', toastConfig)
          return prev
        }

        const updatedAccordions = updateSuggestionsRecursively(prev.accordions)
        toast.success(' attachments copied successfully', toastConfig)

        return { ...prev, accordions: updatedAccordions }
      })

      setSelectedDiagnosis([])
      setSelectedStatement([])
      setSelectedFile([])
    } catch (error) {
      console.error('Error updating suggestions:', error)
      toast.error('Failed to update suggestions', toastConfig)
    } finally {
      setShowMediaModel(false)
    }
  }

  const handleTitleSubmit = () => {
    try {
      const selectedFiles =
        selectedFile?.map((desc) => ({
          type: selectedMediaType?.find((type) => desc.value.includes(type.value))?.value || 'document',
          url: desc.value,
          fileName: desc?.label || '',
        })) ?? []
      setParentAccordions((prev) => {
        if (!prev?.accordions?.length) {
          toast.error('No accordions to update', toastConfig)
          return prev
        }

        const updateDescriptionsRecursively = (accordions) =>
          accordions.map((accordion) =>
            accordion.id === parentId
              ? {
                  ...accordion,
                  attached: {
                    image: [
                      ...(accordion.attached?.image ?? []),
                      ...selectedFiles
                        .filter((f) => f.type === 'image')
                        .map((f) => ({
                          url: f.url,
                          fileName: f?.fileName || '',
                        })),
                    ].flat(),
                    video: [
                      ...(accordion.attached?.video ?? []),
                      ...selectedFiles
                        .filter((f) => f.type === 'video')
                        .map((f) => ({
                          url: f.url,
                          fileName: f?.fileName || '',
                        })),
                    ].flat(),
                    document: [
                      ...(accordion.attached?.document ?? []),
                      ...selectedFiles
                        .filter((f) => f.type === 'document')
                        .map((f) => ({
                          url: f.url,
                          fileName: f?.fileName || '',
                        })),
                    ].flat(),
                  },

                  children: accordion.children ? updateDescriptionsRecursively(accordion.children) : [],
                }
              : {
                  ...accordion,
                  children: accordion.children ? updateDescriptionsRecursively(accordion.children) : [],
                },
          )

        const updatedAccordions = updateDescriptionsRecursively(prev.accordions)

        toast.success('attachments copied successfully', toastConfig)
        return { ...prev, accordions: updatedAccordions }
      })

      setSelectedDiagnosis([])
      setSelectedStatement([])
    } catch (error) {
      console.error('Error updating descriptions:', error)
      toast.error('Failed to update descriptions', toastConfig)
    } finally {
      setShowMediaModel(false)
    }
  }

  const updateNestedSuggestions = (list, parentId, suggestion) => {
    return list?.map((item) =>
      item.id === parentId
        ? {
            ...item,
            suggestions: {
              ...item.suggestions,
              suggestionName: [...item?.suggestions?.suggestionName, ...suggestion],
            },
          }
        : {
            ...item,
            children: updateNestedSuggestions(item.children, parentId, suggestion),
          },
    )
  }

  return (
    <div className="mx-3 patient-theme-copy-shell statement-copy-theme">
      <div
        className="patient-theme-copy-panel p-4"
        style={{
          marginBottom: '20px',
          width: '100%',
          overflowY: 'auto',
        }}
      >
        <div className=" ">
          {differentModuleCopyFunctionality && (
            <div className="mb-3" style={{ width: '100%' }}>
              <CFormLabel className="patient-theme-copy-label">Select Module</CFormLabel>
              <Select
                value={selectedModuleType}
                onChange={setSelectedModuleType}
                options={moduleType}
                isLoading={isPageLoading}
                className="basic-single-select ui-react-select"
                classNamePrefix="select"
              />
            </div>
          )}

          <div className="mb-3" style={{ width: '100%' }}>
            <CFormLabel className="patient-theme-copy-label">Select Diagnosis</CFormLabel>
            <Select
              value={selectedDiagnosis}
              onChange={setSelectedDiagnosis}
              options={diagnosisOptions}
              isLoading={isPageLoading}
              className="basic-single-select ui-react-select"
              classNamePrefix="select"
            />
          </div>

          <CheckOptionSelections options={titleOptions} selectedValue={selectedTitles} setSelectedValue={setSelectedTitles} isPageLoading={isPageLoading} Label={'Select Title'} />

          <CheckOptionSelections options={statementOption.flatMap((item) => item.data || [])} selectedValue={selectedStatement} setSelectedValue={setSelectedStatement} isPageLoading={isPageLoading} Label={'Select Statement'} />
          <CheckOptionSelections options={mediaType} selectedValue={selectedMediaType} setSelectedValue={setSelectedMediaType} isPageLoading={isPageLoading} Label={'Select Media Type'} />

          <CheckOptionSelections
            options={[
              ...(selectedStatement
                ?.flatMap((item) => selectedMediaType?.flatMap((type) => item?.attached?.[type?.value] ?? []))
                .map((file) => ({
                  value: file?.url || '',
                  label: file?.fileName || '',
                  type: file?.url.includes('/image/upload/') ? 'image' : file?.url.includes('/video/upload/') ? 'video' : 'document',
                })) ?? []),

              ...(selectedTitles
                ?.flatMap((title) => selectedMediaType?.flatMap((type) => title?.attached?.[type?.value] ?? []))
                .map((file) => ({
                  value: file?.url || '',
                  label: file?.fileName || '',
                  type: file?.url.includes('/image/upload/') ? 'image' : file?.url.includes('/video/upload/') ? 'video' : 'document',
                })) ?? []),
            ]}
            selectedValue={selectedFile}
            setSelectedValue={setSelectedFile}
            isPageLoading={isPageLoading}
            Label={'Select Attachments'}
          />

          <div className="  d-flex gap-1 w-100" style={{ overflow: 'auto' }}>
            {selectedFile?.map((fileItem, i) => {
              const isImage = fileItem.type === 'image'
              const isVideo = fileItem.type === 'video'
              const isDocument = fileItem.type === 'document'

              return (
                <div
                  key={i}
                  className="shadow rounded p-2 position-relative"
                  style={{
                    width: '100px',
                    height: '100px',
                    overflow: 'hidden',
                    borderRadius: '8px',
                    cursor: 'grab',
                    flexShrink: 0,
                    background: 'var(--ui-bg-inset)',
                    border: '1px solid var(--ui-border-subtle)',
                    position: 'relative',
                  }}
                >
                  {isImage ? (
                    <img
                      src={fileItem.value}
                      alt="Uploaded"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        borderRadius: '8px',
                      }}
                    />
                  ) : isVideo ? (
                    <video
                      controls
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                      }}
                    >
                      <source src={fileItem.value} type="video/mp4" />
                    </video>
                  ) : isDocument ? (
                    <div className="d-flex flex-column align-items-center justify-content-center h-100">
                      <iframe
                        src={fileItem.value}
                        style={{
                          width: '100%',
                          height: '100%',
                          border: 'none',
                          borderRadius: '8px',
                        }}
                        title="Document Viewer"
                      />
                      <a href={fileItem.value} target="_blank" rel="noopener noreferrer" className="text-primary mt-1" style={{ fontSize: '0.7rem', textDecoration: 'none' }}>
                        <div className="d-flex flex-column justify-content-center align-items-center h-100">
                          <i className="bi bi-file-earmark-text-fill fs-1 text-primary"></i>
                          <span className="pb-1" style={{ fontWeight: '600', color: 'var(--ui-text-primary)' }}>
                            Document
                          </span>
                        </div>
                      </a>
                    </div>
                  ) : (
                    <a href={fileItem.value} target="_blank" rel="noopener noreferrer" className="text-center" style={{ color: 'var(--ui-text-primary)' }}>
                      {fileItem.fileName || 'File'}
                    </a>
                  )}
                </div>
              )
            })}
          </div>
        </div>
      </div>
      <div className="text-end">
        <CButton onClick={() => (attachedType === 'title' ? handleTitleSubmit() : handleStatementSubmit())} className="px-4 ui-action-btn ui-action-btn--primary">
          Add
        </CButton>
      </div>
    </div>
  )
}

export default MediaCopy
